export const getEmailDomain = (email: string) => {
    if (!email) {
        return null;
    }

    const parts = email.split('@');
    if (parts.length !== 2) {
        return null;
    }

    const domain = parts[1].split('.')[0];
    if (domain.length === 0) {
        return null;
    }

    return domain;
};
